import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';
import { IGetItemsWithTokenParams } from '../../../../httpClient/serverApi/types/IGetItemsWithTokenParams';
import { ISiteUser } from '../types/ISiteUser';

export interface IGetSiteUsersWithTokenParams extends IGetItemsWithTokenParams {
}

export interface IGetSiteUsersWithTokenResult extends IGetItemsResult {
  users: ISiteUser[];
}

export class GetSiteUsersWithTokenRequest extends Request<IGetSiteUsersWithTokenParams, IGetSiteUsersWithTokenResult> {
  constructor(params: IGetSiteUsersWithTokenParams = {}) {
    super('getSiteUsersWithToken', params);
  }
}